import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

const state = {
  itemList: []
};

const getters = {};

const actions = {
  fetchAll({ commit, state }) {
    $axios.get(axiosBase.getUrls().getCcBjiItemList).then(value => {
      commit("writeAllData", value.data);
    });
  }
};

const mutations = {
  writeAllData(state, data) {
    state.itemList = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
